<template>
  <div class="text-center py-5">
    <h2 class="mb-1">
      Page Not Found
    </h2>
    <p class="mb-2">
      The requested URL was not found on this server.
    </p>

    <b-button
      variant="primary"
      class="mb-2 btn-sm-block"
      :to="{path:'/'}"
    >
      Back to home
    </b-button>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },
}
</script>
